import WranggleRpc from './core';
import LocalObserverTransport from "./local-observer-transport";
export default function registerShortcuts() {
    WranggleRpc.registerTransport('localObserver', (opts) => new LocalObserverTransport(opts));
}
//# sourceMappingURL=register-shortcuts.js.map